import Text from "lib/core/components/text/Text"
import React from "react"

class SubmissionElsewhere extends React.Component {
  static displayName = "SubmissionElsewhere"

  render() {
    return (
      <Text
        html={this.props.submit_elsewhere_instructions}
        theme={true}
        latex={true}
        executeScripts={true}
      />
    )
  }
}

export default SubmissionElsewhere
